import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import Save from './save';

registerBlockType('rielstonenew/gen-why', {
  edit: Edit,
  save: Save,
});
